export const appId = 'ZZB7273V5R';
export const apiKey = '21e00e920c4fc0c9c05cd08c41b4f675';
export const indexName = 'prod_solagoldex';
